import { baseApi } from "../api";
import {
  ApprovedTickerRequest,
  ApproveTickerRequestPayload,
  PendingTickerRequest,
  RejectTickerRequestPayload,
  RequestableExchange,
  SubmittedTickerRequest,
  TickerRequestPayload,
} from "./types";

// Also applied on failure, so a 409 from another admin's resolution refreshes the queue.
const resolutionTags = [
  "TickerRequest" as const,
  "AdminOverview" as const,
  "AdminAuditLog" as const,
  { type: "Instrument" as const, id: "SEARCH" },
];

// `submitTickerRequest` is rate limited (10/hour), so it must only be wired to an explicit action.
export const tickerRequestsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRequestableExchanges: builder.query<RequestableExchange[], void>({
      query: () => ({ url: "/ticker-requests/exchanges" }),
    }),

    submitTickerRequest: builder.mutation<
      SubmittedTickerRequest,
      TickerRequestPayload
    >({
      query: (payload) => ({
        url: "/ticker-requests",
        method: "post",
        data: payload,
      }),
    }),

    getPendingTickerRequests: builder.query<PendingTickerRequest[], void>({
      query: () => ({ url: "/ticker-requests/pending" }),
      providesTags: ["TickerRequest"],
    }),

    approveTickerRequest: builder.mutation<
      ApprovedTickerRequest,
      ApproveTickerRequestPayload
    >({
      query: ({ requestId, approval }) => ({
        url: `/ticker-requests/${requestId}/approve`,
        method: "post",
        data: approval,
      }),
      invalidatesTags: [...resolutionTags, "AdminInstrument"],
    }),

    rejectTickerRequest: builder.mutation<void, RejectTickerRequestPayload>({
      query: ({ requestId, reason }) => ({
        url: `/ticker-requests/${requestId}/reject`,
        method: "post",
        data: { reason },
      }),
      invalidatesTags: resolutionTags,
    }),
  }),
});

export const {
  useGetRequestableExchangesQuery,
  useSubmitTickerRequestMutation,
  useGetPendingTickerRequestsQuery,
  useApproveTickerRequestMutation,
  useRejectTickerRequestMutation,
} = tickerRequestsApi;
